<template>
  <b-alert show variant="warning" class="mb-3">
    <h6 class="font-weight-bold mb-2">Dana Ditangguhkan</h6>
    <p class="mb-0">
      Dana masih menunggu konfirmasi bank.
    </p>
    <p class="mb-2">
      Status akan diperbarui otomatis maksimal T+1.
    </p>
    <p class="font-weight-bold mb-0">
      SBG, Kwitansi, dan Barcode tetap dapat dicetak serta diserahkan kepada
      nasabah.
    </p>
  </b-alert>
</template>

<script>
export default {
  name: "disbursement-pending-alert",
};
</script>
